import request from 'superagent'
import types from '../types'
import Provider from '../../types/Provider'
import Role from '../../types/Role'
import User from '../../types/User'
import Organization from '../../types/Organization'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='')
	api_url = `${protocol}//${hostname}/api`

const getUsersRequested = () => ({
  type: types.GET_USERS_REQUESTED,
  payload: null
})

const getUsersRejected = (error: any) => ({
  type: types.GET_USERS_REJECTED,
  payload: error
})

const getUsersFulfilled = (data: Array<User>) => ({
  type: types.GET_USERS_FULFILLED,
  payload: data
})

export const getUsers = (organization_id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getUsersRequested())
    request
    .get(`${api_url}/users/${organization_id}`)
    .set('Accept', 'application/json')
    .set('access-token',token)
    .then((response) => {
      dispatch(getUsersFulfilled(response.body))
    })
    .catch((error) => {
        dispatch(getUsersRejected(error))
    })
  }
}

const addUserRequested = () => ({
  type: types.ADD_USER_REQUESTED,
  payload: null
})

const addUserRejected = (error: any) => ({
  type: types.ADD_USER_REJECTED,
  payload: error
})

const addUserFulfilled = (data: any) => ({
  type: types.ADD_USER_FULFILLED,
  payload: data
})

export const addUser = (data: { email: string, enabled: boolean, firstName: string, lastName: string, provider_id: Array<string>, role_id: number, organization_id: Array<string> }, token: string) => {
  return (dispatch: any) => {
    dispatch(addUserRequested())
    request
    .post(`${api_url}/user`)
    .set('Accept', 'application/json')
    .set('access-token',token)
	  .send(data)
    .then((response) => {
      dispatch(addUserFulfilled(response.body))
    })
    .catch((error) => {
        dispatch(addUserRejected(error))
    })
  }
}

const updateUserRequested = () => ({
  type: types.UPDATE_USER_REQUESTED,
  payload: null
})

const updateUserRejected = (error: any) => ({
  type: types.UPDATE_USER_REJECTED,
  payload: error
})

const updateUserFulfilled = (data: any) => ({
  type: types.UPDATE_USER_FULFILLED,
  payload: data
})

export const updateUser = (data: {enabled: boolean, first_name: string, last_name: string, role_id: number, user_id: number, provider_id: Array<string>, organization_id: Array<string>, user_organizations: Array<Organization>}, token: string) => {
  return (dispatch: any) => {
    dispatch(updateUserRequested())
    request
    .put(`${api_url}/user`)
    .set('Accept', 'application/json')
    .set('access-token',token)
  	.send(data)
    .then((response) => {
      dispatch(updateUserFulfilled(response.body))
    })
    .catch((error) => {
        dispatch(updateUserRejected(error))
    })
  }
}

const getRolesRequested = () => ({
  type: types.GET_ROLES_REQUESTED,
  payload: null
})

const getRolesRejected = (error: any) => ({
  type: types.GET_ROLES_REJECTED,
  payload: error
})

const getRolesFulfilled = (data: Array<Role>) => ({
  type: types.GET_ROLES_FULFILLED,
  payload: data
})

export const getRoles = (token: string) => {
  return (dispatch: any) => {
    dispatch(getRolesRequested())
    request
    .get(`${api_url}/roles`)
    .set('Accept', 'application/json')
    .set('access-token',token)
    .then((response) => {
      dispatch(getRolesFulfilled(response.body))
    })
    .catch((error) => {
        dispatch(getRolesRejected(error))
    })
  }
}
const getProvidersRequested = () => ({
  type: types.GET_PROVIDERS_REQUESTED,
  payload: null
})

const getProvidersRejected = (error: any) => ({
  type: types.GET_PROVIDERS_REJECTED,
  payload: error
})

const getProvidersFulfilled = (data: Array<Provider>) => ({
  type: types.GET_PROVIDERS_FULFILLED,
  payload: data
})

export const getProviders = (organization_id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getProvidersRequested())
    request
    .get(`${api_url}/providers/${organization_id}`)
    .set('Accept', 'application/json')
    .set('access-token',token)
    .then((response) => {
      dispatch(getProvidersFulfilled(response.body))
    })
    .catch((error) => {
        dispatch(getProvidersRejected(error))
    })
  }
}

const validateProviderUserRequested = () => ({
  type: types.VALIDATE_PROVIDER_ADMIN_USER_REQUESTED,
  payload: null
})

const validateProviderUserRejected = (error: any) => ({
  type: types.VALIDATE_PROVIDER_ADMIN_USER_REJECTED,
  payload: error
})

const validateProviderUserFulfilled = (data: any) => ({
  type: types.VALIDATE_PROVIDER_ADMIN_USER_FULFILLED,
  payload: data
})

export const validateProviderUser = (data:{ email: string }, token: string) => {
  return (dispatch: any) => {
    dispatch(validateProviderUserRequested())
    request
    .post(`${api_url}/providerUser/validation`)
    .set('Accept', 'application/json')
    .set('access-token',token)
	  .send(data)
    .then((response) => {
      dispatch(validateProviderUserFulfilled(response.body))
    })
    .catch((error) => {
      dispatch(validateProviderUserRejected(error))
    })
  }
}